// extracted by mini-css-extract-plugin
module.exports = {"page-detail":"page-detail_page-detail__Z2uAG","is-home-page":"page-detail_is-home-page__O9duj"};